





































import { Vue, Component, Prop } from "vue-property-decorator";
import { Term as ITerm } from "@/api/models/term";
import { TermEdit as ITermEdit } from "@/api/models/term-edit";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import TableActions from "@/components/form/TableActions.vue";
@Component({
  components: { TableActions, CustomTableCol, CustomTableItem }
})
export default class TaxonomyProfessionalActivityItem extends Vue {
  @Prop() term!: ITerm;
  showEditDetail: boolean = false;
  title!: string;
  description?: string;
  isDeletingProcess: boolean = false;

  data() {
    return {
      title: undefined,
      description: undefined
    };
  }

  created() {
    if (this.term) {
      this.title = this.term.title;
      this.description = this.term.description;
    }
  }

  deleteTerm() {
    this.isDeletingProcess = true;
    this.$store
      .dispatch("taxonomy/DocTypes/DELETE_TERM", this.term.id)
      .finally(() => {
        this.isDeletingProcess = false;
      });
  }

  checkForSave() {
    if (!this.showEditDetail) {
      this.showEditDetail = true;
    } else {
      this.applyChange();
    }
  }

  async applyChange() {
    let params: ITermEdit = {
      title: this.title,
      description: this.description
    };
    await this.$store.dispatch("taxonomy/DocTypes/EDIT_TERM", {
      id: this.term.id,
      term: params
    });
    this.$store.commit("taxonomy/DocTypes/CLEAR");
    await this.$store.dispatch("taxonomy/DocTypes/LIST");
    this.showEditDetail = false;
  }
}
